import React from 'react';
import FloorFilterDropdown from '@/components/util/FloorFilterDropdown';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';

export const ReserveFormFloorSelector: React.FC = () => {
  const { resource, floors, filterFloor, setFilterFloor } = useReserveForm();
  return (
    <FloorFilterDropdown
      readonly={!!resource}
      floors={floors ?? []}
      floor={filterFloor}
      setFloor={setFilterFloor}
    />
  );
};
